import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const RemoveParticipantFromLoanSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      onboardingDetailsId: requiredString(t),
    })
    .strict();

export type RemoveParticipantFromLoanType = z.infer<ReturnType<typeof RemoveParticipantFromLoanSchema>>;
